import React from "react";

function Header() {
  return (
    <div>
      <nav className="main-header navbar navbar-expand navbar-primary navbar-dark">
        {/* Left navbar links */}
       
        {/* Right navbar links */}
        <ul className="navbar-nav ml-auto">
          {/* Navbar Search */}
        
          <li className="nav-item">
            <a
              className="nav-link"
              data-widget="fullscreen"
              href="#"
              role="button"
            >
              <i className="fas fa-expand-arrows-alt" />
            </a>
          </li>
          <li className="nav-item">
            <a
              className="nav-link"
              data-widget="control-sidebar"
              data-controlsidebar-slide="true"
              href="#"
              role="button"
            >
              <i className="fas fa-user" />
            </a>
          </li>
        </ul>
      </nav>
    </div>
  );
}

export default Header;
